import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CloseQuoteRequestInput {
    orderId: string;
    quoteRequestId: string;
}

const closeQuoteRequest = async (data: CloseQuoteRequestInput, sessionId: string | null) => {
    return axios.put(`${API_URL}/order/request-quotes/close`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useCloseQuoteRequest = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CloseQuoteRequestInput) => closeQuoteRequest(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['/order/detail', variables.orderId] });
            queryClient.invalidateQueries({ queryKey: ['/order/drawer', variables.orderId] });
            queryClient.invalidateQueries({ queryKey: ['/order/workflow-status', variables.orderId] });
        },
        onError: (error) => {
            console.error('Failed to close quote request:', error);
        },
    });
};
